import ProductItem from './ProductItem';
import Empty from '../Empty';
import isEmpty from 'lodash/isEmpty';
export default function Products({ products, isMobile = false }: any) {
    return (
        <>
            {!isEmpty(products) ? (
                products.map((product: any) => <ProductItem product={product.content} key={product.id} isMobile={isMobile} />)
            ) : (
                <Empty isMobile={isMobile} />
            )}
        </>
    );
}
